
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Box, useTheme, Button, InputBase, IconButton, Menu, MenuItem, TextField, Snackbar, Alert, Modal, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { getMarcacionesView, updateMarcacion } from "../../../services/marcaciones.services";
import { format } from "date-fns";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import * as React from "react";
import dayjs from "dayjs";
import ModalCharge from "../../../modal/modalCharge";
import ExcelJS from 'exceljs';
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import jsPDF from "jspdf";
import "jspdf-autotable";
import DownloadIcon from '@mui/icons-material/Download';


dayjs.extend(duration);
dayjs.extend(utc);


const ListaMarcaciones = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [startDate, setStartDate] = useState(null); // Iniciar con null
  const [endDate, setEndDate] = useState(null); // Iniciar con null
  const [originalData, setOriginalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({ entrada: "", salida: "", salida_almuerzo: "", entrada_almuerzo: "" });
  const [savingEdit, setSavingEdit] = useState(false);
  const [feedback, setFeedback] = useState({ open: false, message: "", severity: "success" });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const computeLlegadaTardia = (entradaRaw, fechaRaw, horaEntradaHorario) => {
    const horaEntradaReal = entradaRaw ? dayjs(entradaRaw) : null;
    const fechaStr = fechaRaw ? dayjs(fechaRaw).format("YYYY-MM-DD") : null;

    if (horaEntradaReal && fechaStr && horaEntradaHorario) {
      const horaEntradaEsperada = dayjs(`${fechaStr} ${horaEntradaHorario}`);
      if (horaEntradaReal.isAfter(horaEntradaEsperada)) {
        const diffMs = horaEntradaReal.diff(horaEntradaEsperada);
        // Solo cuenta si el retraso es mayor o igual a 60 segundos (1 minuto)
        if (diffMs < 60000) return "";
        const diff = dayjs.duration(diffMs);
        return `${String(diff.hours()).padStart(2, "0")}:${String(diff.minutes()).padStart(2, "0")}:${String(diff.seconds()).padStart(2, "0")}`;
      }
    }
    return "";
  };

const puedeGenerarPDFIncompleta = (row) => {
  const fechaStr = row.Fecha ? dayjs(row.Fecha).format("YYYY-MM-DD") : null;
  const horaEntrada = row.hora_entrada;
  const horaSalida = row.hora_salida;

  if (!fechaStr || !horaEntrada || !horaSalida) return false;

  const entrada = dayjs(`${fechaStr} ${horaEntrada}`);
  let salida = dayjs(`${fechaStr} ${horaSalida}`);

  if (!entrada.isValid() || !salida.isValid()) return false;

  // ─── Si la salida es ANTES que la entrada, cruza medianoche → sumar 1 día ───
  if (salida.isBefore(entrada)) {
    salida = salida.add(1, "day");
  }

  return dayjs().isAfter(salida);
};

  // detectar si le faltan marcaciones ───
  const tieneMarcacionesIncompletas = (row) => {
    return !row.entrada || !row.salida_almuerzo || !row.entrada_almuerzo || !row.salida;
  };

  const handleMenuOpen = (event, row) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const formatTimeField = (value) => (value ? dayjs(value).format("HH:mm") : "");

  const handleEditMarcacion = () => {
    if (!menuRow) return;
    setEditForm({
      entrada: formatTimeField(menuRow.entrada),
      salida: formatTimeField(menuRow.salida),
      salida_almuerzo: formatTimeField(menuRow.salida_almuerzo),
      entrada_almuerzo: formatTimeField(menuRow.entrada_almuerzo),
    });
    setIsEditModalOpen(true);
    handleMenuClose();
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setMenuRow(null);
    setEditForm({ entrada: "", salida: "", salida_almuerzo: "", entrada_almuerzo: "" });
  };

  const handleEditInputChange = (field) => (event) => {
    setEditForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const resolveBaseDate = (row) => {
    if (row?.entrada && dayjs(row.entrada).isValid()) {
      return dayjs(row.entrada);
    }
    if (row?.Fecha && dayjs(row.Fecha).isValid()) {
      return dayjs(row.Fecha);
    }
    return dayjs();
  };

  const combineDateAndTime = (row, timeValue, fieldKey) => {
    if (!timeValue) return null;
    const [hours, minutes] = timeValue.split(":").map((value) => Number(value));
    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }

    const fechaReferencia = row?.Fecha && dayjs(row.Fecha).isValid() ? dayjs(row.Fecha) : null;
    const campoExistente = fieldKey && row?.[fieldKey] && dayjs(row[fieldKey]).isValid()
      ? dayjs(row[fieldKey])
      : null;

    let base = campoExistente || resolveBaseDate(row);
    if (fechaReferencia) {
      base = base.year(fechaReferencia.year()).month(fechaReferencia.month()).date(fechaReferencia.date());
    }

    const segundos = campoExistente ? campoExistente.second() : 0;
    const milisegundos = campoExistente ? campoExistente.millisecond() : 0;

    const combinado = base
      .hour(hours)
      .minute(minutes)
      .second(segundos)
      .millisecond(milisegundos);

    return combinado.format("YYYY-MM-DD HH:mm:ss.SSS");
  };

  const handleSaveEdit = async () => {
    if (!menuRow) return;
    setSavingEdit(true);
    try {
        const payload = {
          entrada: combineDateAndTime(menuRow, editForm.entrada, "entrada"),
          salida: combineDateAndTime(menuRow, editForm.salida, "salida"),
          salida_almuerzo: combineDateAndTime(menuRow, editForm.salida_almuerzo, "salida_almuerzo"),
          entrada_almuerzo: combineDateAndTime(menuRow, editForm.entrada_almuerzo, "entrada_almuerzo"),
      };

      await updateMarcacion(menuRow.Id, payload);

      const llegadaTardia = computeLlegadaTardia(payload.entrada, menuRow.Fecha, menuRow.hora_entrada);
      const updatedValues = {
        ...payload,
        llegada_tardia: llegadaTardia,
      };

      const matchesEditedRow = (row) => row.Id === menuRow.Id && row.id_usuario === menuRow.id_usuario;

      setOriginalData((prev) =>
        prev.map((row) => (matchesEditedRow(row) ? { ...row, ...updatedValues } : row))
      );
      setData((prev) => prev.map((row) => (matchesEditedRow(row) ? { ...row, ...updatedValues } : row)));

      setFeedback({ open: true, severity: "success", message: "Marcación actualizada" });
      handleCloseEditModal();
    } catch (error) {
      console.error("Error al actualizar marcación:", error);
      setFeedback({ open: true, severity: "error", message: error.message || "No se pudo actualizar" });
    } finally {
      setSavingEdit(false);
    }
  };

  const handleFeedbackClose = (_, reason) => {
    if (reason === "clickaway") return;
    setFeedback((prev) => ({ ...prev, open: false }));
  };

  const columns = [
    
    {
      field: "acciones",
      headerName: "Acciones",
      sortable: false,
      filterable: false,
      width: 110,
      renderCell: (params) => (
        <IconButton size="small" onClick={(event) => handleMenuOpen(event, params.row)}>
          <MenuIcon />
        </IconButton>
      ),
    },
    { field: "Id", headerName: "ID" },
    // { field: "id_usuario", headerName: "ID_USUARIO" },
    { field: "Id_empleado", headerName: "ID_EMPLEADO" },
    {
      field: "funcionario",
      headerName: "NOMBRE",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "grupo",
      headerName: "GRUPO",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "horas",
      headerName: "HORAS TRABAJADAS",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "entrada",
      headerName: "Entrada",
      flex: 1,
      renderCell: (params) => params.value ? format(new Date(params.value), "HH:mm:ss") : "0",
    },
    {
      field: "salida_almuerzo",
      headerName: "Salida Almuerzo",
      flex: 1,
      renderCell: (params) => params.value ? format(new Date(params.value), "HH:mm:ss") : "0",
    },
    {
      field: "entrada_almuerzo",
      headerName: "Entrada Almuerzo",
      flex: 1,
      renderCell: (params) => params.value ? format(new Date(params.value), "HH:mm:ss") : "0",
    },
    {
      field: "salida",
      headerName: "Salida",
      flex: 1,
      renderCell: (params) => params.value ? format(new Date(params.value), "HH:mm:ss") : "0",
    },
    {
      field: "Fecha",
      headerName: "FECHA",
      flex: 1,
      renderCell: (params) => params.value ? format(new Date(params.value), "dd/MM/yyyy") : "",
    },
    {
      field: "llegada_tardia",
      headerName: "Llegada Tardía",
      flex: 1,
      renderCell: (params) => params.value || ""
    },
    {
    field: "descargar_advertencia",
    headerName: "Advertencia",
    width: 150,
   renderCell: (params) => {
        const tardia = params.row.llegada_tardia;
        const incompleta = tieneMarcacionesIncompletas(params.row) && puedeGenerarPDFIncompleta(params.row);

        if (!tardia && !incompleta) return "";

        return (
          <Box sx={{ display: "flex", gap: "6px", alignItems: "center", height: "100%" }}>
            {tardia && (
              <Button
                variant="contained"
                sx={{ backgroundColor: "#cedc00", color: "#242b43", minWidth: "50px", px: 1 }}
                size="small"
                title="Advertencia por llegada tardía"
                onClick={() => generarPDF(params.row)}
              >
                <DownloadIcon fontSize="large" />
              </Button>
            )}
            {incompleta && (
              <Button
                variant="contained"
                sx={{ backgroundColor: "#07729cda", color: "#ffffff", minWidth: "50px", px: 1 }}
                size="small"
                title="Advertencia por marcaciones incompletas"
                onClick={() => generarPDFIncompleta(params.row)}
              >
                <DownloadIcon fontSize="large" />
              </Button>
            )}
          </Box>
        );
      },
    },


  ];

const generarPDF = (row) => {
  const doc = new jsPDF();

  // Usar Times (similar a Times New Roman)
  doc.setFont("times", "normal");

  const funcionario = row.funcionario;  
  const horaEsperada = row.hora_entrada;
  const entradaDate = row.entrada ? new Date(row.entrada) : null;
  const entradaReal = entradaDate ? format(entradaDate, "HH:mm:ss") : "—";
  const fechaTardia = entradaDate ? format(entradaDate, "dd/MM/yyyy") : "—";
  const minutosTarde = row.llegada_tardia;



  // Logo
  const img = new Image();
  img.src = "/assets/LogoDracena.jpg";

  img.onload = () => {
    doc.addImage(img, "JPEG", 15, 10, 180, 40);

    // Título centrado
    doc.setFontSize(18);
    doc.setFont("times", "bold");
    doc.text("ADVERTENCIA POR LLEGADA TARDÍA", doc.internal.pageSize.getWidth() / 2, 70, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("times", "normal");

    doc.text(`Funcionario: ${funcionario}`, 10, 95);
    doc.text(`Fecha del registro: ${fechaTardia}`, 10, 105);
    doc.text(`Horario de ENTRADA: ${horaEsperada}`, 10, 115);
    doc.text(`Hora de LLEGADA TARDIA: ${entradaReal}`, 10, 125);
    doc.text(`Retraso: ${minutosTarde}`, 10, 135);

    // Mensaje claro sobre acceso y consecuencias
    doc.text(
      "Acceso Temporalmente Inhabilitado: Su credencial de acceso ha sido TEMPORALMENTE DESHABILITADA por el sistema. La puerta permanecerá BLOQUEADA hasta que se presente OBLIGATORIAMENTE en el Departamento de Recursos Humanos para la re-habilitación de su acceso.",
      10,
      150,
      { maxWidth: 190 }
    );

    doc.text(
      "Incumplimiento de Horarios: El registro de llegadas tardías reiteradas constituye una falta al reglamento interno de la empresa, lo cual generará las consecuencias administrativas y financieras pertinentes, según lo establecido en el Contrato de Trabajo y la normativa interna vigente.",
      10,
      165,
      { maxWidth: 190 }
    );
    // Firmas
    doc.text("Firma del Funcionario: ___________________________", 10, 190);
    doc.text("Firma de Recursos Humanos: _______________________", 10, 205);

    // Guardar PDF
    doc.save(`Advertencia_${funcionario}.pdf`);
  };
};

 // ─── nuevo PDF para marcaciones incompletas ───
const generarPDFIncompleta = (row) => {
  const doc = new jsPDF();
  doc.setFont("times", "normal");

  const funcionario = row.funcionario;
  const fechaStr = row.Fecha ? format(new Date(row.Fecha), "dd/MM/yyyy") : "—";

  const img = new Image();
  img.src = "/assets/LogoDracena.jpg";
  img.onload = () => {
    doc.addImage(img, "JPEG", 15, 10, 180, 40);

    doc.setFontSize(18);
    doc.setFont("times", "bold");
    doc.text(
      "INCUMPLIMIENTO DE MARCACIONES",
      doc.internal.pageSize.getWidth() / 2,
      70,
      { align: "center" }
    );

    doc.setFontSize(12);
    doc.setFont("times", "normal");
    doc.text(`Funcionario: ${funcionario}`, 10, 90);
    doc.text(`Fecha del incumplimiento: ${fechaStr}`, 10, 100);

    // Mostrar las marcaciones registradas con hora formateada
    let y = 110;
    if (row.entrada) {
      doc.text(`Entrada: ${format(new Date(row.entrada), "HH:mm")}`, 10, y);
      y += 10;
    }
    if (row.salida_almuerzo) {
      doc.text(
        `Salida Almuerzo: ${format(new Date(row.salida_almuerzo), "HH:mm")}`,
        10,
        y
      );
      y += 10;
    }
    if (row.entrada_almuerzo) {
      doc.text(
        `Entrada Almuerzo: ${format(new Date(row.entrada_almuerzo), "HH:mm")}`,
        10,
        y
      );
      y += 10;
    }
    if (row.salida) {
      doc.text(`Salida: ${format(new Date(row.salida), "HH:mm")}`, 10, y);
      y += 10;
    }

    doc.text(
      `Se ha detectado que el día ${fechaStr} usted NO realizó la totalidad de sus marcaciones requeridas por el sistema de control de marcaciones.`,
      10,
      y + 10,
      { maxWidth: 190 }
    );

    doc.text(
      "Deberá presentarse OBLIGATORIAMENTE en el Departamento de Recursos Humanos para justificar el motivo de las marcaciones faltantes. El incumplimiento de este procedimiento generará las consecuencias administrativas y financieras pertinentes, según lo establecido en el Contrato de Trabajo y la normativa interna vigente.",
      10,
      y + 20,
      { maxWidth: 190 }
    );

    doc.text(
      "Dejar constancia del motivo por el cual no realizó sus respectivas 4(cuatro) marcaciones:",
      10,
      y + 45,
      { maxWidth: 190 }
    );
    doc.text("Motivo: ____________________________________________", 10, y + 68);
    doc.text("___________________________________________________", 10, y + 78);

    doc.text("Firma del Funcionario: ___________________________", 10, y + 103);
    doc.text("Firma de Recursos Humanos: _______________________", 10, y + 116);

    doc.save(
      `Incumplimiento_Marcaciones_${funcionario}_${fechaStr.replace(/\//g, "-")}.pdf`
    );
  };
};




  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
  const fetchData = async () => {
    try {
      const datos = await getMarcacionesView();
      const enrichedData = datos.map(row => {
        const llegadaTardia = computeLlegadaTardia(row.entrada, row.Fecha, row.hora_entrada);
        return { ...row, llegada_tardia: llegadaTardia };
      });

      setOriginalData(enrichedData);
      setData(enrichedData);
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
    }
  };

  fetchData();
}, []);


  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    const filterByDateRange = () => {
      let filtered = originalData;
  
      if (startDate && endDate) {
        // Aseguramos que la fecha de fin sea hasta el final del día
        const endOfDay = dayjs(endDate).endOf("day");
  
        filtered = originalData.filter((item) => {
          const itemDate = dayjs(item.Fecha);
          // Filtrar desde la fecha de inicio hasta el final del día de la fecha de fin
          return itemDate.isBetween(startDate, endOfDay, null, "[]");  // "[]" hace que sea inclusivo en ambas fechas
        });
      }
  
      const searchFiltered = filtered.filter((item) =>
        item.funcionario.toLowerCase().includes(searchValue.toLowerCase())
      );
  
      setData(searchFiltered);
    };
  
    filterByDateRange();
  }, [startDate, endDate, searchValue, originalData]);

  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Resumen');
  
    // Agregar las columnas con encabezados
    worksheet.columns = [
        { header: 'Nombre', key: 'nombre', width: 20 },
        { header: 'Apellido', key: 'apellido', width: 20 },
        { header: 'Sector', key: 'sector', width: 15 },
        { header: 'Entrada', key: 'entrada', width: 10 },
        { header: 'Salida Almuerzo', key: 'salida_almuerzo', width: 12 },
        { header: 'Entrada Almuerzo', key: 'entrada_almuerzo', width: 10 },
        { header: 'Salida', key: 'salida', width: 12 },
        { header: 'Fecha', key: 'fecha', width: 15 },
        { header: 'Llegada Tardía', key: 'llegada_tardia', width: 15 },
    ];
  
    // Agregar datos al worksheet

    const exportableData = data.map(row => {
  const { nombre, apellido, grupo, entrada, salida_almuerzo, entrada_almuerzo, salida, Fecha, hora_entrada } = row;

  const horaEntradaReal = entrada ? dayjs(entrada) : null;
  const fechaStr = Fecha ? dayjs(Fecha).format("YYYY-MM-DD") : null;
  let llegadaTardia = "";

  if (horaEntradaReal && fechaStr && hora_entrada) {
    const horaEntradaEsperada = dayjs(`${fechaStr} ${hora_entrada}`);
    if (horaEntradaReal.isAfter(horaEntradaEsperada)) {
      const diffMs = horaEntradaReal.diff(horaEntradaEsperada);
      const diff = dayjs.duration(diffMs);
      llegadaTardia = `${String(diff.hours()).padStart(2,"0")}:${String(diff.minutes()).padStart(2,"0")}:${String(diff.seconds()).padStart(2,"0")}`;
    }
  }

  return {
    nombre: nombre || 'Sin Registro',
    apellido: apellido || 'Sin Registro',
    sector: grupo || 'Sin Registro',
    entrada: entrada ? dayjs(entrada).format('HH:mm:ss') : 'Sin Registro',
    salida_almuerzo: salida_almuerzo ? dayjs(salida_almuerzo).format('HH:mm:ss') : '0',
    entrada_almuerzo: entrada_almuerzo ? dayjs(entrada_almuerzo).format('HH:mm:ss') : '0',
    salida: salida ? dayjs(salida).format('HH:mm:ss') : '0',
    fecha: Fecha ? dayjs(Fecha).format('DD/MM/YYYY') : '0',
    llegada_tardia: llegadaTardia,
  };
});



    worksheet.addRows(exportableData);

    // Aplicar estilos a las cabeceras
    worksheet.getRow(1).eachCell((cell) => {
        cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
        };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '143f04' },
        };
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
    });

    // Revisar datos y aplicar estilos solo a las celdas con valores inválidos
    worksheet.eachRow((row, rowNumber) => {
        if (rowNumber === 1) return; // Saltar la cabecera

        let rowHasInvalidData = false; // Flag para verificar si la fila tiene datos inválidos

        row.eachCell((cell) => {
            // Si el valor es 'Sin Registro' (lo que indica que el dato es inválido)
            if (cell.value === '0') {
                rowHasInvalidData = true; // Marcar que la fila tiene un dato inválido
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF0000' }, // Fondo rojo
                };
                cell.font = { color: { argb: 'FFFFFF' } }; // Texto blanco
            }

            // Aplicar bordes a todas las celdas
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        // Si la fila tiene algún dato inválido, poner fondo rojo en toda la fila
        if (rowHasInvalidData) {
            row.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF0000' }, // Fondo rojo
                };
            });
        }
    });

    // Guardar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Resumen_Asistencia.xlsx';
    link.click();
};

  // Función para asignar una clase a cada fila dependiendo del Estado
  const getRowClassName = (params) => {
    const salida = params.row.salida;
    
    // Si salida es null, 0 o "0", asignar la clase para la fila
    if (!salida || salida === "0" || salida === 0) {
      return "fila-invalida"; // Nombre de clase personalizada para filas inválidas
    }
    
    return ""; // Sin clase para las filas que no cumplen la condición
  };

  
  return (
    <Box m="20px">
    <Box display="flex" justifyContent="space-between" p={0}>
      <Header
        title="Resumen de Asistencias"
        subtitle="Resumen de Asistencia "
      />
      <Box display="flex" alignItems="center">
        {/* <Button
          disabled={!activeButton}
          onClick={() => setModalEditWorks(true)}
          color="secondary"
          variant="contained"
        >
          Editar
        </Button>

        <Button
          disabled={!activeButton}
          onClick={() => setModalDialogo(true)}
          color="secondary"
          variant="contained"
          sx={{
            backgroundColor: "#e41811",
            color: "#ffffff ",
            marginLeft: "10px",
          }}
        >
          Eliminar
        </Button> */}
 <Box sx={{
    marginRight:"2%",
    marginLeft:"2%",

  }}>
              
              <Button sx={{
                background:"#143f04",
                width:"100%",
                height:"3rem!important",
                color:"white",
                borderRadius:"8px", "&:hover": {
                  background: "#36a60f", // Color de fondo cuando el botón está en hover
                },
                
              }} onClick={handleExport} variant="contained" color="primary">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/732/732220.png"
                  alt="Excel Icon"
                  style={{ width: 24, height: 24, marginRight: 8 }}
                />
                Exportar
              </Button>
              </Box>
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          height={"50%"}
          width={"100%"}
          ml={1}
        >
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder="Buscar"
            value={searchValue}
            onChange={handleSearchChange}
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>

    <Box
      m="40px 0 0 0"
      height="75vh"
      sx={{
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
        },
        "& .name-column--cell": {
          color: colors.greenAccent[300],
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[900],
          borderBottom:"0.5px solid #5f5d5d",
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[900],
        },
        "& .MuiCheckbox-root": {
          color: `${colors.greenAccent[200]} !important`,
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
        },

          // Estilos para las filas con hover
          "& .fila-invalida": {
            backgroundColor: "#740017", // Fondo rojo
            color: "#FFFFFF", // Texto blanco
            // borderBottom:"0.5px solid #5f5d5d",
            "&:hover": {
              backgroundColor: "#CC0000", // Fondo más oscuro al pasar el ratón
            },
          },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "-1%",
          marginRight: "5px",
        }}
      >
        <Box >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]}>
              <DatePicker
                label="Fecha de Inicio"
                value={startDate}
                onChange={(newValue) => setStartDate(dayjs(newValue))}
                format="DD/MM/YYYY"
              />
              <DatePicker
                label="Fecha de Fin"
                value={endDate}
                onChange={(newValue) => setEndDate(dayjs(newValue))}
                format="DD/MM/YYYY"
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
   
        </Box >

        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => `${row.Id}_${row.id_usuario}`}
          getRowClassName={getRowClassName}
          components={{ Toolbar: GridToolbar }}
        />
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={handleEditMarcacion}>Editar marcación</MenuItem>
        </Menu>
      </Box>
      <Modal
        open={isEditModalOpen}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-editar-marcacion"
        aria-describedby="modal-editar-marcacion-descripcion"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 520,
            bgcolor: colors.primary[400],
            borderRadius: "8px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Typography id="modal-editar-marcacion" variant="h5">
              Editar marcación
            </Typography>
            <IconButton onClick={handleCloseEditModal} sx={{ color: colors.grey[400] }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="grid" gridTemplateColumns="repeat(2, minmax(0, 1fr))" gap={2} mb={3}>
            <TextField
              label="Entrada"
              type="time"
              value={editForm.entrada}
              onChange={handleEditInputChange("entrada")}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            
            <TextField
              label="Salida almuerzo"
              type="time"
              value={editForm.salida_almuerzo}
              onChange={handleEditInputChange("salida_almuerzo")}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Entrada almuerzo"
              type="time"
              value={editForm.entrada_almuerzo}
              onChange={handleEditInputChange("entrada_almuerzo")}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Salida"
              type="time"
              value={editForm.salida}
              onChange={handleEditInputChange("salida")}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>
          <Box
            id="modal-editar-marcacion-descripcion"
            bgcolor={colors.blueAccent[800]}
            borderRadius="4px"
            p={2}
            mb={3}
          >
            <Typography variant="body2" color={colors.grey[100]}>
              Ajusta los horarios según corresponda. Los cambios quedan registrados en el historial de marcaciones una vez confirmes.
            </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleCloseEditModal} disabled={savingEdit} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleSaveEdit} variant="contained" disabled={savingEdit}>
              {savingEdit ? "Guardando..." : "Guardar"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <ModalCharge isLoading={isLoading} />
      <Snackbar open={feedback.open} autoHideDuration={4000} onClose={handleFeedbackClose}>
        <Alert onClose={handleFeedbackClose} severity={feedback.severity} sx={{ width: "100%" }}>
          {feedback.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ListaMarcaciones;